export class RateLimiter {
    private readonly windowMs: number;
    private readonly max: number;
    private readonly errorProducer: () => Error;
    private count = 0;

    constructor({
        max,
        windowMs = 1000,
        errorProducer = () => new Error('Limit exceeded'),
    }: {
        max: number;
        windowMs?: number;
        errorProducer?: () => Error;
    }) {
        this.max = max;
        this.windowMs = windowMs;
        this.errorProducer = errorProducer;
    }

    checkLimit() {
        if (this.count === 0) {
            setTimeout(() => (this.count = 0), this.windowMs);
        }

        this.count += 1;

        if (this.count > this.max) {
            throw this.errorProducer();
        }
    }
}
